import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
    selector: 'fuse-confirm',
    template: `
    <h1 mat-dialog-title>{{ title }}</h1>
    <div mat-dialog-content>{{ message }}</div>
    <div mat-dialog-actions>
        <button
        type="button"
        mat-raised-button
        style="background-color:#004D40; color: #ffffff"
        (click)="dialogRef.close(true)">
            {{aceptar}}
        </button>
        &nbsp;
        <span fxFlex></span>
        <button
        type="button"
        mat-raised-button
        (click)="dialogRef.close(false)">
            {{cancelar}}
        </button>
    </div>`,
})
export class ComfirmComponent {

    public title: string;
    public message: string;
    public aceptar: string;
    public cancelar: string;

    constructor(public dialogRef: MatDialogRef<ComfirmComponent>) {

    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/confirm/confirm.component.ts